export const LeftIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.5303 17.4697C27.8231 17.7626 27.8231 18.2374 27.5303 18.5303L22.2374 23.8232C22.1673 23.8933 22.1105 23.9501 22.0622 24C22.1105 24.0499 22.1673 24.1067 22.2374 24.1768L27.5303 29.4697C27.8231 29.7626 27.8231 30.2374 27.5303 30.5303C27.2374 30.8232 26.7625 30.8232 26.4696 30.5303L21.1767 25.2374C21.1686 25.2294 21.1605 25.2212 21.1523 25.2131C21.0072 25.0681 20.8503 24.9113 20.7358 24.7612C20.6015 24.5852 20.457 24.3335 20.457 24C20.457 23.6665 20.6015 23.4148 20.7358 23.2388C20.8503 23.0887 21.0072 22.9319 21.1523 22.7869C21.1605 22.7788 21.1686 22.7706 21.1767 22.7626L26.4696 17.4697C26.7625 17.1768 27.2374 17.1768 27.5303 17.4697Z"
      fill="#18191B"
    />
  </svg>
);
